var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import * as React from 'react';
import { analytics } from 'app/utils/segment';
import styles from './messageAudio.module.scss';
function generateTimeStamp(duration) {
    const stampLength = duration >= 3600 ? 8 : 5;
    if (Number.isNaN(duration))
        return '00:00';
    return new Date(duration * 1000)
        .toISOString()
        .substr(19 - stampLength, stampLength);
}
export class MessageAudio extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            playing: false,
            actuallyPlaying: false,
            progress: 0,
            duration: 0,
            changingDuration: 0,
            audioSrc: '',
        };
        this.handleSegmentEvent = this.handleSegmentEvent.bind(this);
        this.audioRef = React.createRef();
        this.playerRef = React.createRef();
        this.handleTogglePlayClick = this.handleTogglePlayClick.bind(this);
        this.updateProgress = this.updateProgress.bind(this);
        this.handleHandleGrab = this.handleHandleGrab.bind(this);
        this.handleHandleMove = this.handleHandleMove.bind(this);
        this.handleHandleDrop = this.handleHandleDrop.bind(this);
        this.handlePlayerClick = this.handlePlayerClick.bind(this);
        this.handleRecordingDownload = this.handleRecordingDownload.bind(this);
        this.setAudio = this.setAudio.bind(this);
    }
    componentDidMount() {
        if (this.audioRef.current) {
            this.audioRef.current.addEventListener('loadeddata', () => {
                if (this.audioRef.current) {
                    const { duration } = this.audioRef.current;
                    this.setState({
                        duration,
                        changingDuration: duration,
                    });
                }
            });
        }
        if (this.audioRef.current) {
            const audioRef = this.audioRef.current;
            this.audioRef.current.addEventListener('ended', () => {
                this.setState({
                    playing: false,
                });
                this.setProgress(0);
                this.handleSegmentEvent(audioRef, 'ended');
            });
        }
        this.loadAudioSrc();
    }
    componentWillUnmount() {
        if (this.state.playing && this.audioRef.current) {
            this.handleSegmentEvent(this.audioRef.current, 'navigated_away');
        }
    }
    handleSegmentEvent(element, event) {
        const { currentTime, duration } = element;
        const { conversation, date } = this.props;
        const eventData = {
            csid: conversation.id,
            createdAt: Math.floor(new Date(date).getTime()),
            direction: conversation.direction,
            channel: conversation.initial_channel,
            recordingDuration: duration,
            progress: event === 'ended' ? duration : currentTime,
            currentTimestamp: new Date().getTime(),
        };
        switch (event) {
            case 'play':
                return analytics.phoneRecordingPlayClicked(eventData);
            case 'pause':
                return analytics.phoneRecordingPauseClicked(eventData);
            case 'navigated_away':
                return analytics.phoneRecordingPlaybackAbandoned(eventData);
            case 'ended':
                return analytics.phoneRecordingPlaybackEnded(eventData);
            case 'downloaded':
                return analytics.phoneRecordingDownloaded(eventData);
        }
    }
    updateProgress() {
        if (this.audioRef.current) {
            const { currentTime, duration } = this.audioRef.current;
            const { playing } = this.state;
            this.setState({
                progress: currentTime / duration,
                changingDuration: duration,
            });
            if (playing) {
                window.requestAnimationFrame(this.updateProgress);
            }
        }
    }
    handleTogglePlayClick() {
        const { playing, actuallyPlaying } = this.state;
        if (this.audioRef.current) {
            if (playing && actuallyPlaying) {
                this.handleSegmentEvent(this.audioRef.current, 'pause');
                this.audioRef.current.pause();
                this.setState({
                    playing: false,
                    actuallyPlaying: false,
                });
            }
            else if (!playing) {
                this.handleSegmentEvent(this.audioRef.current, 'play');
                this.setState({
                    playing: true,
                });
                this.audioRef.current.play().then(() => {
                    this.setState({
                        actuallyPlaying: true,
                    });
                });
                window.requestAnimationFrame(this.updateProgress);
            }
        }
    }
    handleRecordingDownload() {
        this.props.onDownload();
        if (this.audioRef.current) {
            this.handleSegmentEvent(this.audioRef.current, 'downloaded');
        }
    }
    handleHandleMove(event) {
        event.preventDefault();
        if (this.startProgress && this.startX && this.playerWidth) {
            let p = this.startProgress + (event.clientX - this.startX) / this.playerWidth;
            if (p > 1)
                p = 1;
            if (p < 0)
                p = 0;
            this.setProgress(p);
        }
    }
    handleHandleDrop() {
        window.removeEventListener('mousemove', this.handleHandleMove);
        window.removeEventListener('mouseup', this.handleHandleDrop);
    }
    handleHandleGrab(event) {
        if (this.playerRef.current) {
            const { progress } = this.state;
            this.startX = event.clientX;
            this.startProgress = progress;
            this.playerWidth = this.playerRef.current.getBoundingClientRect().width;
            window.addEventListener('mousemove', this.handleHandleMove);
            window.addEventListener('mouseup', this.handleHandleDrop);
        }
    }
    handlePlayerClick(event) {
        if (this.playerRef.current) {
            this.startX = event.clientX;
            const bounds = this.playerRef.current.getBoundingClientRect();
            const p = (event.clientX - bounds.left) / bounds.width;
            this.setProgress(p);
            this.startProgress = p;
            this.playerWidth = bounds.width;
            window.addEventListener('mousemove', this.handleHandleMove);
            window.addEventListener('mouseup', this.handleHandleDrop);
        }
    }
    setProgress(progress) {
        if (this.audioRef.current) {
            const { duration } = this.state;
            this.audioRef.current.currentTime = progress * duration;
        }
        this.updateProgress();
    }
    loadAudioSrc() {
        const { soundfile: { src }, } = this.props;
        if (typeof src === 'string') {
            this.setAudio(src);
        }
        else {
            src()
                .then((result) => {
                this.setAudio(result);
            })
                .catch(() => {
                /* do nothing */
            });
        }
    }
    setAudio(src) {
        this.setState({
            audioSrc: src,
            duration: 0,
            progress: 0,
            playing: false,
            changingDuration: 0,
        });
    }
    render() {
        const _a = this.props, { className, soundfile, title } = _a, otherProps = __rest(_a, ["className", "soundfile", "title"]);
        const { playing, progress, duration, changingDuration, audioSrc } = this.state;
        const rootClass = classnames({
            [styles.messageAudio]: true,
        }, className);
        return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass }, { children: [_jsx(IconButton, { variant: "secondary", icon: playing ? 'pause' : 'play', className: styles.control, onClick: this.handleTogglePlayClick }), _jsx(IconButton, { variant: "secondary", icon: "cloud-download", className: styles.control, onClick: this.handleRecordingDownload }), _jsxs("div", Object.assign({ className: styles.playerWrap }, { children: [_jsx("p", Object.assign({ className: styles.title }, { children: title })), _jsx("time", Object.assign({ className: styles.timestamp }, { children: generateTimeStamp(progress * duration) })), _jsxs("div", Object.assign({ className: styles.player, ref: this.playerRef, onMouseDown: this.handlePlayerClick }, { children: [_jsx("div", { className: styles.handle, style: {
                                        left: `${progress * 100}%`,
                                    }, onMouseDown: this.handleHandleGrab }), _jsx("div", { className: styles.progress, style: {
                                        width: `${progress * 100}%`,
                                    } })] })), _jsx("time", Object.assign({ className: styles.timestamp }, { children: generateTimeStamp(changingDuration) }))] })), _jsx("audio", Object.assign({ ref: this.audioRef }, { children: audioSrc && _jsx("source", { src: audioSrc, type: soundfile.type }) }))] })));
    }
}
